<!-- ── READ-ONLY: Activity Report summary ───────────────────────────────────── -->
<div *ngIf="read_only" class="action-panel report-panel">
  <div class="action-panel-header report-header" (click)="opened = !opened" style="cursor:pointer;">
    <i class="fa fa-file-text-o" style="margin-right:6px;"></i>
    Activity Report Summary
    <i class="fa report-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="opened" class="action-panel-body">
    <p *ngIf="!toSubmit" class="action-panel-desc">
      The service is finished. Below is the Activity Report being submitted.
    </p>
    <p class="report-title">{{ title }}</p>

    <div class="report-summary" #summaryBox>
      <div class="report-summary-row" *ngFor="let key of getKeys()">
        <div class="report-summary-key">{{ key }}</div>
        <div class="report-summary-val">
          <i *ngIf="summary[key] === true" class="fa fa-check"></i>
          <span *ngIf="summary[key] !== true">
            <div [innerHTML]="summary[key]"></div>
          </span>
        </div>
      </div>
    </div>

    <div class="report-actions">
      <button (click)="exportReportSummary()" class="btn btn-default action-btn action-btn--secondary">
        <i class="fa fa-download"></i> Export PDF
      </button>
    </div>
  </div>
</div>

<!-- ── EDIT: Activity Report form ───────────────────────────────────────────── -->
<div *ngIf="!read_only" class="action-panel report-panel">
  <div class="action-panel-header report-header" (click)="opened = !opened" style="cursor:pointer;">
    <i class="fa fa-file-text-o" style="margin-right:6px;"></i>
    Activity Report
    <i class="fa report-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="opened" class="action-panel-body">
    <p *ngIf="toSubmit" class="action-panel-desc">
      Fill in the activity report in all its sections by the end of the service.
    </p>
    <p class="report-title">{{ title }}</p>

    <form-error-summary [errors]="fieldErrors" (jumpTo)="jumpToField($event)"></form-error-summary>

    <div class="report-topics" *ngIf="getTopicTags() && getTopicTags()!.length">
      <h6 class="report-section-title">Project's topics and sub-topics</h6>
      <ul class="topic-list">
        <li *ngFor="let topic of getTopicTags()">{{ topic }}</li>
      </ul>
    </div>

    <div class="report-questions">
      <ng-container *ngFor="let question of questions">
        <open-question *ngIf="isOpenQuestion(question)"
                       [type]="'report'"
                       [question]="getQuestionKey(question)"
                       [editor]="getQuestion(question)"
                       [description]="getQuestionDescription(question)"
                       [required]="isFieldRequired(getQuestionKey(question))"
                       [submitted]="submitted">
        </open-question>
        <tick-box *ngIf="!isOpenQuestion(question)"
                  [fields]="question"
                  [type]="'report'"
                  [description]="getQuestionDescription(question)"
                  [required]="isFieldRequired(getQuestionKey(question))"
                  [submitted]="submitted">
        </tick-box>
      </ng-container>
    </div>

    <div class="report-actions">
      <button *ngIf="toSubmit" (click)="confirm()" class="btn btn-primary action-btn">
        <i class="fa fa-save"></i> Save report
      </button>
      <button (click)="exportReportSummary()" class="btn btn-default action-btn action-btn--secondary">
        <i class="fa fa-download"></i> Export PDF
      </button>
    </div>
  </div>
</div>

<svg class="inline-svg">
  <symbol id="check" viewBox="0 0 12 10">
    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
  </symbol>
</svg>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
